<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-28" dir="rtl">
    <div class="max-w-3xl mx-auto space-y-4">
      <div v-for="(item, idx) in items" :key="idx" class="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div class="flex items-center gap-3 p-4">
          <div class="soft-blob w-14 h-12 text-white flex items-center justify-center" style="--g1:#c4b5fd; --g2:#7c3aed;">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927l1.902 3.853 4.254.618-3.078 3  .726 4.234-3.804-2-3.804 2 .726-4.234-3.078-3  4.254-.618 1.902-3.853z" />
            </svg>
          </div>
          <div class="w-full">
            <div class="text-sm font-bold text-gray-900">نظر مشتری</div>
            <div class="text-xs text-gray-500">نتیجه نظرسنجی سرویس</div>
          </div>
          <div class="px-3 py-1 rounded-full bg-purple-50 text-purple-700 text-xs font-bold w-24 text-center">
            امتیاز: {{ item.rate }}
          </div>
        </div>
        <div class="px-4 pb-4">
          <div class="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
            {{ item.answer }}
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<style scoped>
.soft-blob {
  border-radius: 16px;
  background: linear-gradient(145deg, var(--g1, #a78bfa), var(--g2, #7c3aed));
}
</style>
<script>
// import the styles

import axios from 'axios'
import Vue from 'vue'

import {bus} from '../../main'
import moment from 'moment-jalaali'

export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      items: [],
    }
  },
  computed: {},
  components: {},
  watch: {},
  mounted() {
    this.profile()

  },
  methods: {
    profile() {

      var self = this;

      var formData = new FormData();

      // formData.append('mobile',this.user_mobile.replace('+98',"0"))
      formData.append('Id',localStorage.getItem('userId2'))
      // formData.append('Id',JSON.parse(localStorage.getItem('profile')).UserId)

      //
      var obj ={
        Id:   JSON.parse(localStorage.getItem('profile')).UserId
      }
      // GetTechAllSurvay
      // this.axios.post('/Register' , send_data,{
      this.axios.post('https://panel.zoodkomak.com/jetToken/GetTechProfile', obj, {})
        .then(response => {
          self.get_survey_report(response.data.data.UdD)

        }).catch(e => {
        self.errors.push(e);
        bus.$emit('show_toast', [2000, e])

      })
    },

    get_survey_report(id) {
      // this.request_items = [];
      var self = this
      var formData = new FormData();
      formData.append('id',id)
      var url = 'https://rpt.zoodkomak.com/api/GetTechAllSurvay'
      // this.axios.post('/Register' , send_data,{
      this.axios.post(url, formData, {})
        .then(response => {
          self.items = response.data.data.reverse()

        }).catch(e => {
        this.errors.push(e)
      })
    },

  },

}
</script>
